import React from 'react';
import classNames from 'classnames';

import './LoadingIndicator.scss';

const LoadingIndicator = React.forwardRef(({ title, className }, ref) => {
	return (
		<div className={classNames('loading-screen', className)} ref={ref}>
			<video
				width="299"
				height="299"
				className="loading-screen-spinner"
				title={title}
				aria-hidden="true"
				autoPlay
				loop
				playsInline
				muted
			>
				<source src="/alt/fshr/design3/images/FS-loader-transparent.webm" type="video/webm" />
			</video>
		</div>
	);
});

export default LoadingIndicator;
